import { Box, HStack, Text, VStack, BoxProps } from "@chakra-ui/react";
import { ArrowDownIcon, ArrowUpIcon } from "@chakra-ui/icons";

const StatCard = ({
  title,
  value,
  info,
  percentage,
  isKYD = false,
  highlight = false,
  ...props
}: {
  title: string;
  value: number | string;
  info?: string;
  percentage?: number;
  isKYD?: boolean;
  highlight?: boolean;
} & BoxProps) => {
  const isPositive = percentage >= 0;
  return (
    <VStack
      bgGradient="linear(180deg, rgba(231, 233, 239, 0.3) 0%, #FFF 100%)"
      boxShadow="0px 1px 2px 0px rgba(255, 255, 255, 0.75) inset, 0px 4px 12px -5px rgba(0, 0, 0, 0.04)"
      position="relative"
      border={"1px solid #DDDDDD"}
      borderRadius={"10px"}
      alignItems={"flex-start"}
      p={"16px"}
      gap={"16px"}
      width={"100%"}
      lineHeight={"100%"}
      {...props}
    >
      <HStack gap={"4px"}>
        {highlight && (
          <Box
            bgColor={"#C0DC26F5"}
            width={"10px"}
            height={"10px"}
            borderRadius={100}
            display="flex"
            justifyContent="center"
            alignItems="center"
          />
        )}
        <Text fontSize={"13px"} fontWeight={"400"}>
          {title}
        </Text>
      </HStack>
      <HStack>
        <Text fontSize={"24px"} fontWeight={"400"}>
          {value}
        </Text>
        {info && (
          <Text
            fontSize={"12px"}
            fontWeight={"400"}
            color={"#718096"}
            height={2.5}
          >
            {info}
          </Text>
        )}
        {percentage && (
          <Text
            color={isPositive ? "#6DCB24" : "#718096"}
            fontSize={"12px"}
            fontWeight={"600"}
          >
            {isPositive ? (
              <ArrowUpIcon mb={0.5} color="#6DCB24" />
            ) : (
              <ArrowDownIcon mb={0.5} color="#718096" />
            )}
            {percentage}%
          </Text>
        )}
      </HStack>
      {isKYD && (
        <Box
          position="absolute"
          top={"8px"}
          right={"8px"}
          bgColor={"#D3F227"}
          width={"28px"}
          height={"28px"}
          borderRadius={8}
          border={"1px solid #C0DC26BF"}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <img
            src="/crown.png"
            alt="KYD"
            style={{ opacity: "0.70" }}
            width={16}
          />
        </Box>
      )}
    </VStack>
  );
};
export default StatCard;
